var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inline)?_c('div',{staticClass:"codegen-shell codegen-shell--inline"},[_vm._t("default")],2):_c('b-modal',{attrs:{"size":"xl","id":_vm.modalId,"title":_vm.title,"hide-footer":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }